module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst headOptions = model.headOptions || {}\nconst headConfig = {\nbootstrapVersion: config.bootstrapVersion,\nstatic: config.static,\nregisterSecret: config.registerSecret\n}\nconst cssClasses = {\nelement: ['element'],\ncontentContainer: ['contentContainer'],\ncontent: ['content'],\n}\nif(config.bootstrapVersion){\ncssClasses.element.push('accordion-item')\ncssClasses.contentContainer.push('accordion-collapse')\ncssClasses.content.push('accordion-body')\n}\nif(config.open){\ncssClasses.contentContainer.push('active')\nif(config.bootstrapVersion){\ncssClasses.contentContainer.push('show')\n}\n}\n%><div class=\"<%- cssClasses.element.join(' ') %>\">\n<%- include('./head', { config: headConfig, model }) %>\n<div class=\"<%- cssClasses.contentContainer.join(' ') %>\">\n<div class=\"<%- cssClasses.content.join(' ') %>\">\n<%- helpers.renderSection('content', false); %>\n</div>\n</div>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\accordion\\element.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const headOptions = model.headOptions || {}
const headConfig = {
bootstrapVersion: config.bootstrapVersion,
static: config.static,
registerSecret: config.registerSecret
}
const cssClasses = {
element: ['element'],
contentContainer: ['contentContainer'],
content: ['content'],
}
if(config.bootstrapVersion){
cssClasses.element.push('accordion-item')
cssClasses.contentContainer.push('accordion-collapse')
cssClasses.content.push('accordion-body')
}
if(config.open){
cssClasses.contentContainer.push('active')
if(config.bootstrapVersion){
cssClasses.contentContainer.push('show')
}
}

    ; __line = 24
    ; __append("<div class=\"")
    ; __append( cssClasses.element.join(' ') )
    ; __append("\">\n")
    ; __line = 25
    ; __append( include('./head', { config: headConfig, model }) )
    ; __append("\n<div class=\"")
    ; __line = 26
    ; __append( cssClasses.contentContainer.join(' ') )
    ; __append("\">\n<div class=\"")
    ; __line = 27
    ; __append( cssClasses.content.join(' ') )
    ; __append("\">\n")
    ; __line = 28
    ; __append( helpers.renderSection('content', false) )
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 31
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\accordion\element.ejs

}